function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, onMounted, computed } from "vue";
import TaskCenterEnter from "./task-center-enter.vue";
import TaskCenterList from "./task-center-list.vue";
import { getAsyncJobs, updateAsyncRead } from "@pt/api/common";
import _ from "lodash";
import axios from "axios";
import { Unread } from "@pt/enums/jobs";
export default defineComponent({
    components: {
        TaskCenterEnter: TaskCenterEnter,
        TaskCenterList: TaskCenterList
    },
    props: {
        dark: {
            type: Boolean,
            default: false
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleClick = function handleClick() {
            visible.value = false;
        };
        var taskList = ref([]);
        var loading = ref(false);
        var visible = ref(false);
        /** 任务状态变更，红点提示 */ var badge = computed(function() {
            return taskList.value.some(function(t) {
                return t.is_unread === Unread.Yes;
            });
        });
        var ListCancelToken = axios.CancelToken;
        var listSource = null;
        function getTaskList() {
            return _getTaskList.apply(this, arguments);
        }
        function _getTaskList() {
            _getTaskList = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res, list;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loading.value = true;
                            if (listSource) {
                                listSource.cancel("cancel request");
                                setTimeout(function() {
                                    loading.value = true;
                                }, 0);
                            }
                            listSource = ListCancelToken.source();
                            _ctx.next = 5;
                            return getAsyncJobs({
                                cancelToken: listSource.token
                            }).finally(function() {
                                loading.value = false;
                            });
                        case 5:
                            res = _ctx.sent;
                            list = _.get(res, "data.data") || [];
                            taskList.value = list;
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getTaskList.apply(this, arguments);
        }
        function handleShow() {
            return _handleShow.apply(this, arguments);
        }
        function _handleShow() {
            _handleShow = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var ids;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ids = taskList.value.filter(function(t) {
                                return t.is_unread === Unread.Yes;
                            }).map(function(t) {
                                return t.id;
                            });
                            if (!ids.length) {
                                _ctx.next = 4;
                                break;
                            }
                            _ctx.next = 4;
                            return updateAsyncRead(ids);
                        case 4:
                            getTaskList();
                            emit("show");
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _handleShow.apply(this, arguments);
        }
        onMounted(function() {
            getTaskList();
        });
        return {
            taskList: taskList,
            loading: loading,
            badge: badge,
            visible: visible,
            handleShow: handleShow,
            // 暴露给外部使用
            getTaskList: getTaskList,
            handleClick: handleClick
        };
    }
});
